<template>
    <div class="text-[#2b2b2b]">
        <div class="mb-[8px] flex items-center gap-x-[8px] justify-between">
            <div class="flex items-center gap-x-[8px]">
                <div class="relative w-[270px] h-[35px]">
                    <Search color="#2b2b2b" :size="16" strokeWidth="1.3" class="absolute left-4 top-1/2 -translate-y-1/2"/>
                    <input
                        type="text"
                        v-model="globalFilter"
                        placeholder="Rechercher..."
                        class="py-3 pr-3 pl-[32px] size-full border font-light rounded-xl focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"
                    />
                </div>
            </div>
            <div class="grow">
                <slot name="other-filter"></slot>
            </div>
            <!-- <div>
                <button class="h-[35px] px-[12px] bg-[#3c41e9] text-white rounded-md flex items-center gap-x-[12px] font-light">
                    <FolderUp color="#ffffff" :size="16" strokeWidth="1.3"/>
                    Exporter vers excel
                </button>
            </div> -->
        </div>
        
        <div class="border rounded-xl border-[#eaeaea]">
            <table class="w-full rounded-lg overflow-hidden divide-y divide-[#eaedef] border border-[#eaeaea]">
                <thead class="bg-[#fcfbfc] rounded-lg">
                    <tr v-for="headerGroup in table.getHeaderGroups()" :key="headerGroup.id">
                        <th
                            v-for="header in headerGroup.headers"
                            :key="header.id"
                            :colSpan="header.colSpan"
                            :class="{
                                'py-3 px-4 h-[45px] text-[#666a7c] text-left border-l border-l-[#f3f3f3] font-normal': true,
                                'cursor-pointer select-none': header.column.getCanSort(),
                            }"
                            @click="header.column.getToggleSortingHandler()?.($event)">
                            <template v-if="!header.isPlaceholder">
                                <div class="flex items-center justify-between">
                                {{ header.column.columnDef.header }}
                                    <div v-if="header.column.getCanSort()">
                                        <ArrowUpDown v-if="!header.column.getIsSorted()" color="#666a7c"  :size="16" strokeWidth="1.7"/>
                                        <template v-else>
                                            <ArrowUp v-if="header.column.getIsSorted() === 'asc'" color="#666a7c"  :size="16" strokeWidth="1.7"/>
                                            <ArrowDown v-else color="#666a7c"  :size="16" strokeWidth="1.7"/>
                                        </template>
                                    </div>
                                </div>
                            </template>
                            </th>
                        </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-[#f3f3f3]">
                            <template v-if="!load">
                                <tr v-for="row in table.getRowModel().rows" :key="row.id" class="hover:bg-[#f8f9fd]">
                                    <td v-for="(cell,idx) in row.getVisibleCells()" :key="cell.id"
                                        class="py-4 px-4 h-[50px] border-l border-l-[#f3f3f3] text-[12.5px] font-light text-[#2b2b2b]">
                                        <slot name="row-cell" :value="cell.getValue()" :cellNumber="idx"></slot>
                                    </td>
                                </tr>
                                <tr v-if="table.getRowModel().rows.length === 0">
                                    <td :colspan="columns.length" class="py-4 px-4 h-[50px] text-center font-light text-[#2b2b2b]">
                                        Aucune donnée trouvée.
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr v-for="(_,idx) in Array(5).fill(1)" :key="idx" class="animate-pulse">
                                    <td :colspan="columns.length" class="p-6 h-[50px]">
                                        <div class="size-full rounded-xl bg-gray-100"/>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
            </table>
        </div>
        <div class="mt-[8px] flex items-center justify-between">
            <div class="flex items-center gap-[12px]">
                <select
                    :value="table.getState().pagination.pageSize"
                    @change="e => {
                    table.setPageSize(Number(e.target.value))}"
                        class="px-[12px] h-[35px] border rounded-xl font-light">
                        <option v-for="pageSize in [10, 20, 30, 40, 50]" :key="pageSize" :value="pageSize">
                        Afficher {{ pageSize }}
                        </option>
                </select>

                <span class="flex font-extralight items-center gap-x-[12px]">
                        Page
                        <strong>
                        {{ table.getState().pagination.pageIndex + 1 }} sur
                        {{ table.getPageCount() }}
                        </strong>
                </span>
            </div>

            <div class="flex items-center font-light gap-[12px]">
                <!-- <button
                    @click="table.setPageIndex(0)"
                    :disabled="!table.getCanPreviousPage()"
                    class="p-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >&lt;&lt;</button> -->

                <span class="flex items-center gap-x-[6px] font-extralight">
                    Aller à la page:
                    <input
                        type="number"
                        :value="table.getState().pagination.pageIndex + 1"
                        @change="e => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                            table.setPageIndex(page)
                    }" class="w-[60px] p-3 h-[35px] border rounded-xl text-center font-light"/>
                </span>

                <button
                        @click="table.previousPage()"
                        :disabled="!table.getCanPreviousPage()"
                        class="px-[12px] h-[35px] border cursor-pointer rounded-xl hover:bg-gray-50 disabled:opacity-50"
                >Précedent</button>

                <button
                    @click="table.nextPage()"
                    :disabled="!table.getCanNextPage()"
                    class="px-[12px] h-[35px] border cursor-pointer rounded-xl hover:bg-gray-50 disabled:opacity-50"
                >Suivant</button>

                <!-- <button
                    @click="table.setPageIndex(table.getPageCount() - 1)"
                    :disabled="!table.getCanNextPage()"
                    class="p-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >&gt;&gt;</button> -->
            </div>
        </div>
        <slot name="bottom-popup"></slot>
    </div>
</template>
<script>
import {
  getCoreRowModel,
  getPaginationRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useVueTable,
} from "@tanstack/vue-table";
import {Search,ArrowUpDown,ArrowDown,ArrowUp} from "lucide-vue-next";
export default {
    name:"CustomTable",
    components:{Search,ArrowUpDown,ArrowDown,ArrowUp},
    props:["data","columnsCustom","load"],
    data(){
        return {
            globalFilter: '',
            pagination: {
                pageIndex: 0,
                pageSize: 10,
            },
            sorting: [],
        }
    },
    computed: {
        columns() {
            return this.columnsCustom;
            },
            table() {
            return useVueTable({
                data: this.data,
                columns: this.columnsCustom,
                getCoreRowModel: getCoreRowModel(),
                getPaginationRowModel: getPaginationRowModel(),
                getFilteredRowModel: getFilteredRowModel(),
                getSortedRowModel: getSortedRowModel(),
                state: {
                pagination: this.pagination,
                globalFilter: this.globalFilter,
                sorting: this.sorting,
                },
                onPaginationChange: updater => {
                this.pagination = typeof updater === 'function' ? updater(this.pagination) : updater;
                },
                onGlobalFilterChange: updater => {
                this.globalFilter = typeof updater === 'function' ? updater(this.globalFilter) : updater;
                },
                onSortingChange: updater => {
                this.sorting = typeof updater === 'function' ? updater(this.sorting) : updater;
                },
            });
        },
    },
}
</script>